const STORAGE_KEY = 'orderfix:cookie-consent';
const REOPEN_EVENT = 'orderfix:cookie-reopen';
const CHANGED_EVENT = 'orderfix:cookie-changed';

export const DEFAULT_CONSENT = {
  functional: false,
  analytics: false,
  marketing: false,
};

export function getConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return { ...DEFAULT_CONSENT, ...JSON.parse(raw) };
  } catch {
    return null;
  }
}

export function hasMadeChoice() {
  if (typeof window === 'undefined') return true;
  try {
    return localStorage.getItem(STORAGE_KEY) !== null;
  } catch {
    return true;
  }
}

export function setConsent(consent) {
  if (typeof window === 'undefined') return;
  try {
    const normalized = { ...DEFAULT_CONSENT, ...consent };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  } catch {
    // ignore quota/private-mode errors
  }
  window.dispatchEvent(new Event(CHANGED_EVENT));
}

export function onConsentChange(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(CHANGED_EVENT, handler);
  return () => window.removeEventListener(CHANGED_EVENT, handler);
}

export function acceptAll() {
  setConsent({ functional: true, analytics: true, marketing: true });
}

export function rejectNonEssential() {
  setConsent({ functional: false, analytics: false, marketing: false });
}

export function reopenBanner() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(REOPEN_EVENT));
}

export function onReopenBanner(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(REOPEN_EVENT, handler);
  return () => window.removeEventListener(REOPEN_EVENT, handler);
}
